import { render } from "./GerenciamentoImpostos.vue?vue&type=template&id=2bc7d0e0&scoped=true"
import script from "./GerenciamentoImpostos.vue?vue&type=script&lang=js"
export * from "./GerenciamentoImpostos.vue?vue&type=script&lang=js"

import "./GerenciamentoImpostos.vue?vue&type=style&index=0&id=2bc7d0e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc7d0e0"]])

export default __exports__